import { config } from "../config";
export const formatPhoneNumber = (phone) => {
    if (config('isNASite'))
        return phone.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3')
    return phone;
}